"use client";

import { useCallback, useEffect, useState } from "react";
import { lineApi } from "@/lib/api";
import { BILLIN_SERVICE_ID } from "@/lib/billinConstants";

export const DEFAULT_BILLIN_LINE_DEEP_LINK =
  process.env.NEXT_PUBLIC_BILLIN_LINE_DEEP_LINK?.trim() ?? "";

export type LineBillinBindStatus = {
  bound: boolean;
  lineUserId?: string;
  code?: string;
  fullText?: string;
  deepLink?: string;
  oaInfo?: { name?: string; pictureUrl?: string };
};

export function useLineBillinBindStatus(
  serviceId: string | null | undefined = BILLIN_SERVICE_ID,
) {
  const [bindStatus, setBindStatus] = useState<LineBillinBindStatus | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);

  const refetch = useCallback(async () => {
    const id = serviceId?.trim() || BILLIN_SERVICE_ID;
    try {
      const res = (await lineApi.getBindStatus(id)) as LineBillinBindStatus;
      setBindStatus(res);
    } catch {
      setBindStatus({
        bound: false,
        deepLink: DEFAULT_BILLIN_LINE_DEEP_LINK,
      });
    } finally {
      setIsLoading(false);
    }
  }, [serviceId]);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  const deepLink =
    bindStatus?.deepLink?.trim() || DEFAULT_BILLIN_LINE_DEEP_LINK;

  return { bindStatus, isLoading, deepLink, refetch };
}

/** @deprecated Use useLineBillinBindStatus */
export function useLineBillinDeepLink(
  serviceId: string | null | undefined = BILLIN_SERVICE_ID,
) {
  const { deepLink } = useLineBillinBindStatus(serviceId);
  return deepLink;
}
